import React, { useState, useEffect, useMemo } from "react";
// import classes from "../../assets/styles/Pages/Function/MemoryListing.module.css";
import ShowMemoryFunctions from "../../components/PageComponents/Function/ShowMemoryFunctions";
import Loader from "../../components/Loader";
import { useAtom } from "jotai";
import { get, deleteRecord, post, put } from "../../server";
import { MEMORY, FUNCTION_STATUS } from "../../utils/constants/apiUrl";
import {
  loggedInUser,
  teamIDCheck,
  subscribedPackage,
} from "../../utils/store";
import { toast } from "react-toastify";
import showToast from "../../helpers/showToast";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import MemoryAddEditModal from "../../components/Modals/MemoryAddEditModal";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import FormInput from "../../components/Forms/FormInput";
import searchIcon from "../../assets/images/global_icons/searchicon.svg";
import _ from "lodash";
import EmptyListingBanner from "../../components/EmptyListingBanner";
import useFunctionsCount from "../../hooks/useFunctionsCount";
import functionTypes from "../../utils/constants/functionTypes";
import { FaCirclePlus } from "react-icons/fa6";
import FunctionsLimitModal from "../../components/Modals/FunctionsLimitModal";
import { trackEvent } from "../../utils/mixpanel";
import AddIcon from "../../assets/images/global_icons/basil_add-solid.svg";
import { Button } from "react-bootstrap";

const MemoryListing = () => {
  let emptyMemoryData = {
    id: "",
    media_type: "",
    save_type: "",
    title: "",
    reminder: "",
    medias: [],
    team_id: "",
  };
  const navigate = useNavigate();
  const { teamId, userId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");

  const [loading, setLoading] = useState(true);
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [memories, setMemories] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(emptyMemoryData);
  const [filterText, setFilterText] = useState("");
  const [errors, setErrors] = useState({});
  const {
    compareLimits,
    updateCount,
    limitExceededForStarter,
    compareLimitsForDynamicQR,
  } = useFunctionsCount();
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  // Handle main modal
  const handleShowModal = (obj) => {
    if (obj && Object.keys(obj).length) setSelectedData(obj);
    setShowModal(true);
  };

  const handleShowMemoryModal = async () => {
    if (dynamicQRCodeId) {
      const isLimitExceeded = compareLimitsForDynamicQR(
        functionTypes.MEMORY,
        dynamicQRCodeId
      );
      if (isLimitExceeded) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        setShowModal(true);
      }
    } else if (purchasedPackage.id === 1) {
      limitExceededForStarter()
        .then((isLimitExceeded) => {
          if (isLimitExceeded) {
            setShowLimitModal(true);
          } else {
            setShowModal(true);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      const isLimitExceeded = compareLimits(functionTypes.MEMORY);
      if (isLimitExceeded) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        setShowModal(true);
      }
    }
  };

  // const handleSaveShowModal = async () => {
  //   setLoading(true);
  //   // let payload = _.cloneDeep(selectedData);
  //   // payload.media = formatUrl(payload.media);
  //   const formData = new FormData();
  //   formData.append("media_type", selectedData.media_type);
  //   formData.append("save_type", selectedData.save_type);
  //   formData.append("title", selectedData.title);
  //   formData.append("reminder", selectedData.reminder);
  //   // Append each selected media file to FormData
  //   const mediaFiles = Array.isArray(selectedData.media)
  //     ? selectedData.media
  //     : [];
  //   mediaFiles.forEach((file, index) => {
  //     formData.append(`media[${index}]`, file);
  //   });
  //   let result = {};
  //   if (selectedData.id) {
  //     result = await post(
  //       MEMORY + `/update/${selectedData.id}`,
  //       formData,
  //       Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //     );
  //   } else {
  //     if (teamId && userId) {
  //       formData.team_id = teamId;
  //     }
  //     if (team_id && user_id) {
  //       formData.team_id = team_id;
  //     }
  //     if (userTeamId) {
  //       formData.team_id = userTeamId;
  //     }
  //     result = await post(
  //       MEMORY,
  //       formData,
  //       Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //     );
  //   }

  //   let { status, message, data } = result;

  //   if (status) {
  //     setLoading(false);
  //     if (!selectedData.id) {
  //       updateCount(functionTypes.MEMORY, functionTypes.ADD);
  //     }
  //     let memoriesArr = _.cloneDeep(memories);

  //     // On Update
  //     if (selectedData.id) {
  //       const index = memories.findIndex((el) => el.id == selectedData.id);
  //       memoriesArr[index] = data;
  //     } else {
  //       memoriesArr.unshift(data);
  //     }

  //     setMemories(memoriesArr);
  //     handleCloseModal();
  //   } else {
  //     setLoading(false);
  //   }

  //   showToast(status, message);
  // };
  const handleSaveShowModal = async () => {
    setLoading(true);

    let newErrors = {};

    if (!selectedData.title || selectedData.title.trim() === "") {
      newErrors.title = "Title is required";
    }

    if (!selectedData.media_type) {
      newErrors.media_type = "Media type is required";
    }

    if (!selectedData.save_type) {
      newErrors.save_type = "Save type is required";
    }

    if (!selectedData.id) {
      if (
        !selectedData.medias ||
        (Array.isArray(selectedData.medias) && selectedData.medias.length === 0)
      ) {
        newErrors.medias = "At least one media file is required";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }

    setErrors({});

    const formData = new FormData();
    formData.append("media_type", selectedData.media_type);
    formData.append("save_type", selectedData.save_type);
    formData.append("title", selectedData.title);
    formData.append("reminder", selectedData.reminder);
    formData.append("dynamic_qr_code_id", dynamicQRCodeId);

    // Check if media is edited or unchanged
    if (
      selectedData.id && // Editing an existing memory
      _.isEqual(selectedData.medias, emptyMemoryData.medias) // No change in media
    ) {
      formData.append("medias", null);
    } else {
      // Append media files if they exist
      const mediaFiles = Array.isArray(selectedData.medias)
        ? selectedData.medias
        : [];
      mediaFiles.forEach((file, index) => {
        formData.append(`medias[${index}]`, file);
      });
    }

    let result = {};
    const isNew = !selectedData.id;

    const searchParams = new URLSearchParams(window.location.search);
    const source = dynamicQRCodeId
      ? "QR Code"
      : searchParams.has("team_id") && searchParams.has("user_id")
      ? "Team Function"
      : "Function Page";
    if (selectedData.id) {
      result = await post(
        MEMORY + `/update/${selectedData.id}`,
        formData,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
    } else {
      if (teamId && userId) {
        formData.append("team_id", teamId);
      }
      if (team_id && user_id) {
        formData.append("team_id", team_id);
      }
      if (userTeamId) {
        formData.append("team_id", userTeamId);
      }
      result = await post(
        MEMORY,
        formData,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
    }

    const { status, message, data } = result;

    trackEvent(`Memory ${isNew ? "Created" : "Updated"} from ${source}`, {
      outcome: status ? "Success" : "Failed",
      message,
      source,
      dynamic_qr_code_id: dynamicQRCodeId || null,
      team_id: formData.team_id || null,
      user_id: formData.user_id || null,
      request_payload: formData,
      response_data: data || null,
      timestamp: new Date().toISOString(),
    });

    if (status) {
      setLoading(false);
      if (!selectedData.id) {
        updateCount(functionTypes.MEMORY, functionTypes.ADD, dynamicQRCodeId);
      }
      const memoriesArr = _.cloneDeep(memories);

      if (selectedData.id) {
        const index = memories.findIndex((el) => el.id == selectedData.id);
        memoriesArr[index] = data;
      } else {
        memoriesArr.unshift(data);
      }

      setMemories(memoriesArr);
      showToast(status, message);
      handleCloseModal();
    } else {
      setLoading(false);
      showToast(
        false,
        message ||
          "File is too large. Please try with another file or compress the file."
      );
    }

    // showToast(status, message);
  };

  const handleCloseModal = () => {
    setSelectedData(emptyMemoryData);
    setShowModal(false);
    setShowLimitModal(false);
    setErrors({});
  };

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (id) => {
    setDeleteId(id);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let queryParams = "";

    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }

    if (teamId || team_id || userTeamId) {
      queryParams += `${queryParams ? "&" : "?"}team_id=${
        teamId || team_id || userTeamId
      }`;
    }

    // if (teamId || team_id || userTeamId) {
    //   queryParams = `?team_id=${teamId || team_id || userTeamId}`;
    // }

    let { status, message } = await deleteRecord(
      `${MEMORY}/${deleteId}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);

    if (status) {
      updateCount(functionTypes.MEMORY, functionTypes.DELETE, dynamicQRCodeId);
      await getMemories();
      setLoading(false);
    }
    setLoading(false);
  };

  // Get all custom urls
  const getMemories = async () => {
    let queryParams = "";

    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }

    if (teamId || team_id || userTeamId) {
      queryParams += `${queryParams ? "&" : "?"}team_id=${
        teamId || team_id || userTeamId
      }`;
    }

    // if (teamId || team_id || userTeamId) {
    //   queryParams = `?team_id=${teamId || team_id || userTeamId}`;
    // }
    let { status, message, data } = await get(
      `${MEMORY}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setMemories(data);
    } else {
      toast.error(message);
    }
    setLoading(false);
  };

  const handleStatus = async (id) => {
    const allMemories = memories.find((memory) => memory.id === id);
    let newStatus = allMemories.status == true ? 0 : 1;
    const previousStatus = allMemories.status ? "Active" : "Inactive";
    const newStatusText = newStatus ? "Active" : "Inactive";

    const source = window.location.search.includes("dynamic_qr_code")
      ? "QR Code"
      : window.location.search.includes("team_id") &&
        window.location.search.includes("user_id")
      ? "Team Function"
      : "Function Page";
    let queryParams = "";

    const team_id = searchParams.get("team_id");
    const user_id = searchParams.get("user_id");
    const dynamic_qr_code = searchParams.get("dynamic_qr_code");

    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }
    const payload = {
      id: allMemories.id,
      status: newStatus,
      type: allMemories.qrCodeCustomize.function_type,
      team_id: allMemories.team_id,
    };
    let { status, message } = await post(
      `${FUNCTION_STATUS}${queryParams}`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      trackEvent(`Memory Upload Status Changed from ${source}`, {
        id,
        function_type: allMemories.function_type,
        new_status: newStatusText,
        previous_status: previousStatus,
        source,
        team_id,
        user_id,
        dynamic_qr_code,
      });
      await getMemories();
    } else {
      trackEvent(`Memory Upload Status Changed failed from ${source}`, {
        id,
        function_type: allMemories.function_type,
        attempted_status: newStatusText,
        previous_status: previousStatus,
        source,
        team_id,
        user_id,
        dynamic_qr_code,
        error_message: message,
      });
      toast.error(message);
    }
    setLoading(false);
  };

  useEffect(() => {
    getMemories();
  }, [userTeamId]);

  const filteredItems = useMemo(() => {
    const filtered = memories.filter((item) =>
      `${item.title || ""}`.toLowerCase().includes(filterText.toLowerCase())
    );

    return filtered;
  }, [filterText, memories]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleTracking = (data) => {
    trackEvent(data, {
      message: data,
    });
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="mainWrapper heading">
            <h1 className="">
              {/* <Link
                  onClick={handleGoBack}
                  style={{ color: "var(--heading_text_color)" }}
                >
                  Functions
                </Link> */}
              <Link to="/" className="function-link">
                Functions
              </Link>
              {` > Memory`}
            </h1>
            {/* <div className="d-flex align-items-center justify-content-center">
              {memories.length !== 0 ? (
                <FormInput
                  icon={searchIcon}
                  placeholder="Search..."
                  value={filterText}
                  handleChange={handleFilter}
                />
              ) : null}
              {dynamicQRCodeId !== null ? (
                <Link className="primary_button ms-4" to={`/qrcode`}>
                  {`< Back`}
                </Link>
              ) : (
                ""
              )}
            </div> */}

            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3 mobileViewWrapper">
              <div className="d-flex align-items-center gap-3">
                {(Object.keys(loggedUser).length !== 0 &&
                  loggedUser.role.includes("customer")) ||
                loggedUser.role.includes("team_owner") ? (
                  <Button variant="primary" onClick={handleShowMemoryModal}>
                    <img src={AddIcon} alt="plus" className="me-2" /> Upload
                    Memory
                  </Button>
                ) : null}

                {dynamicQRCodeId !== null ? (
                  <Link className="primary_button" to={`/qrcode`}>
                    {`< Back`}
                  </Link>
                ) : null}
              </div>
            </div>
          </div>

          <div className="mb-3">
            {memories.length !== 0 ? (
              // <FormInput
              //   icon={searchIcon}
              //   placeholder="Search..."
              //   value={filterText}
              //   handleChange={handleFilter}
              // />
              <div
                className="input-group"
                style={{ maxWidth: "250px", height: "48px" }}
              >
                <span className="input-group-text bg-white border-end-0">
                  <img
                    src={searchIcon}
                    alt="search"
                    style={{ height: "16px" }}
                  />
                </span>
                <input
                  type="text"
                  className="form-control border-start-0"
                  placeholder="Search..."
                  value={filterText}
                  onChange={handleFilter}
                />
              </div>
            ) : null}
          </div>
          {memories.length === 0 ? (
            <EmptyListingBanner
              headLineText="Memory"
              title="Upload Memory"
              // onClick={handleShowMemoryModal}
              onClick={() => {
                handleShowMemoryModal();
                handleTracking("Upload Memory button Clicked");
              }}
              showAdd={
                loggedUser.role.includes("customer") ||
                loggedUser.role.includes("team_owner")
              }
            />
          ) : (
            <div className="customURLSWrapper">
              <div>
                {/* <div className="addWrapper">
                  {(Object.keys(loggedUser).length !== 0 &&
                    loggedUser.role.includes("customer")) ||
                  loggedUser.role.includes("team_owner") ? (
                    <span onClick={handleShowMemoryModal}>
                      <div className="addContentWrapper">
                        <FaCirclePlus />
                        <p>Upload Memory</p>
                      </div>
                    </span>
                  ) : null}
                </div> */}

                <ShowMemoryFunctions
                  loading={loading}
                  show={showModal}
                  memories={filteredItems}
                  handleShowModal={handleShowModal}
                  handleCloseModal={handleCloseModal}
                  handleDelete={handleDelete}
                  handleStatus={handleStatus}
                  teamId={teamId}
                  userId={userId}
                  team_id={team_id}
                  user_id={user_id}
                  getMemories={getMemories}
                  dynamicQRCodeId={dynamicQRCodeId}
                />
              </div>
            </div>
          )}

          {/* Memory modals */}
          {showModal && (
            <MemoryAddEditModal
              show={showModal}
              data={selectedData}
              setSelectedData={setSelectedData}
              handleSaveShowModal={handleSaveShowModal}
              handleCloseModal={handleCloseModal}
              error={errors}
              setError={setErrors}
            />
          )}
        </div>
      )}

      {/* confirmation modal */}

      <ConfirmationModal
        show={showConfirmationModal}
        handleCloseModal={handleCloseConfirmationModal}
        handleConfirmDelete={handleConfirmDelete}
        confirmTitle="Memory"
      />
      <FunctionsLimitModal
        show={showLimitModal}
        handleClose={handleCloseModal}
        getData={getMemories}
      />
    </>
  );
};

export default MemoryListing;
